module.exports = __webpack_public_path__ + "static/img/4.6e9328c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/4.png
// module id = KSfM
// module chunks = 0